import React, { useEffect } from "react"
import { useTableContext } from "../../provider"

export const InitializerHeight = () => {

  const ctx = useTableContext()
  const { tableId } = ctx.props

  useEffect(() => {

    const { disableAutoHeight } = ctx.props

    const autoHeight = !disableAutoHeight && window.screen.height < 1200

    ctx.table.api.setState((prev) => ({
      ...prev,
      autoHeight
    }))
  }, [])

  return (<></>)
}
